import { render, staticRenderFns } from "./editDialogFwbz.vue?vue&type=template&id=f4ab157e"
import script from "./editDialogFwbz.vue?vue&type=script&lang=ts"
export * from "./editDialogFwbz.vue?vue&type=script&lang=ts"
import style0 from "./editDialogFwbz.vue?vue&type=style&index=0&id=f4ab157e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports